module.exports = __webpack_public_path__ + "static/media/bg-congrats.be9b7d28.png";